import Box from "ds/components/Box";
import Badge from "ds/components/Badge";
import { BadgeProps } from "ds/components/Badge/types";

import { CellComponentProps, EntityType } from "../types";

const TYPE_LABELS = {
  [EntityType.User]: "User",
  [EntityType.UserGroup]: "IdP group",
  [EntityType.ApiKey]: "API key",
  [EntityType.Stack]: "Stack",
};

const TYPE_COLORS: Record<EntityType, BadgeProps["variant"]> = {
  [EntityType.User]: "blue",
  [EntityType.UserGroup]: "turquoise",
  [EntityType.ApiKey]: "fuchsia",
  [EntityType.Stack]: "purple",
};

type RoleUsedByListItemTypeCellProps = CellComponentProps;

const RoleUsedByListItemTypeCell = ({ entity }: RoleUsedByListItemTypeCellProps) => {
  return (
    <Box fullWidth>
      <Badge type="weak" variant={TYPE_COLORS[entity.type]} text={TYPE_LABELS[entity.type]} />
    </Box>
  );
};

export default RoleUsedByListItemTypeCell;
